import { useEffect, useState } from "react";
import HomeSlider from "../../components/HomeSlider";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import SingleVehicleCard from "../../components/Vehicles/SingleVehicleCard";
import {
  getArticles,
  getBannersFiltered,
  getImportedVehicles,
  getNewVehicles,
  getNewVehiclesOffers,
  getShowroomsFor,
  getUsedVehicles,
  ShowroomResource,
} from "../../utils/fetcher";
import SingleUsedVehicleCard from "../../components/Vehicles/SingleUsedVehicleCard";
import ShowroomCardsSlider from "../../components/Showrooms/ShowroomCardsSlider";
import ViewMore from "../../components/Vehicles/ViewMore";
import style from "./index.module.css";
import LatestNews from "../../components/News/LatestNews";
import { useScrollToTop } from "../../utils/generalUtils";
import Banner from "../../components/Vehicles/Banner";
import { useTranslation } from "../../hooks/useTranslation";
import { vehicleModules, vehicleTypes } from "../../utils/GeneralTypes";

// TODO: add types instead of any
type componentDataT = {
  new_buses: any;
  new_buses_offers: any;
  used_buses: any;
  imported_buses: any;
  banners: any;
};

const Home = () => {
  const { locale } = useTranslation();

  useScrollToTop();

  // TODO: add types to the fetchers and it will propagate to the components
  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: componentDataT;
  }>({
    isFetching: true,
    data: {
      new_buses: null,
      new_buses_offers: null,
      used_buses: null,
      imported_buses: null,
      banners: null,
    },
  });

  useEffect(() => {
    // TODO: add types to the fetchers and it will propagate to the components
    const data: componentDataT = {
      new_buses: null,
      new_buses_offers: null,
      used_buses: null,
      imported_buses: null,
      banners: null,
    };
    (async () => {
      const res = await Promise.all([
        getNewVehiclesOffers("bus", "?number=3"),
        getNewVehicles("bus", "?number=3"),
        getUsedVehicles("bus", "?number=3"),
        getImportedVehicles("bus", "?number=3"),
        getBannersFiltered("home_page_banner"),
      ]);
      data.new_buses_offers = res[0]?.data?.vehicles?.data;
      data.new_buses = res[1]?.data.vehicles?.data;
      data.used_buses = res[2]?.data.vehicles?.data;
      data.imported_buses = res[3]?.data.vehicles?.data;
      data.banners = res[4]?.data?.banners;

      setComponentData({
        isFetching: false,
        data,
      });
    })();
  }, []);

  return (
    <>
      <div className="main_section">
        <div className="container-lg">
          <HomeSlider />
        </div>
      </div>
      {((componentData.data.new_buses_offers?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
        <>
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <h3 className="main_section__title main_section__title--small main_section__title--center">
                  {locale("new_bus_offers")}
                </h3>
                <div className={style.all_vehicles}>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <>
                      <div className={`${style.all_vehicles__row} row`}>
                        {componentData.data.new_buses_offers.map((vehicle: any) => (
                          <div key={vehicle.id} className="col-md-4 col-sm-6">
                            <SingleVehicleCard
                              brand={{
                                image: vehicle?.model?.brand?.logo,
                                link: `/new-buses/find?brand=${vehicle?.model?.brand?.id}`,
                                name: vehicle?.model?.brand?.name,
                              }}
                              has_discount={vehicle.has_discount}
                              has_free_maintenance={vehicle?.has_free_maintenance}
                              image={
                                vehicle?.images && vehicle?.images.length > 0
                                  ? vehicle?.images[0].image
                                  : vehicle?.model?.image
                              }
                              link={`/new-${vehicleModules[0].plural}/${vehicleModules[0].single}/${vehicle.id}`}
                              model={vehicle?.model?.name}
                              old_price={vehicle?.old_price}
                              price={vehicle.price}
                              year={vehicle?.model?.year}
                              selling_flag={vehicle?.selling_flag}
                            />
                          </div>
                        ))}
                      </div>
                      <ViewMore link={`/new-${vehicleModules[0].plural}/find`} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {((componentData.data.new_buses?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
        <>
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <div className="section_separator"></div>
              </div>
            </div>
          </div>
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <h3 className="main_section__title main_section__title--small main_section__title--center">
                  {locale("new_bus_releases")}
                </h3>
                <div className={style.all_vehicles}>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <>
                      <div className={`${style.all_vehicles__row} row`}>
                        {componentData.data.new_buses.map((vehicle: any) => (
                          <div key={vehicle.id} className="col-md-4 col-sm-6">
                            <SingleVehicleCard
                              card_style="newReleasesContain"
                              brand={{
                                image: vehicle?.model?.brand?.logo,
                                link: `/new-${vehicleModules[0].plural}/find?brand=${vehicle?.model?.brand?.id}`,
                                name: vehicle?.model?.brand?.name,
                              }}
                              has_discount={vehicle.has_discount}
                              has_free_maintenance={vehicle?.has_free_maintenance}
                              image={vehicle?.model?.image}
                              link={`/distributor/${vehicleModules[0].plural}/${vehicleModules[0].single}/${vehicle.id}`}
                              model={vehicle?.model?.name}
                              old_price={vehicle?.old_price}
                              price={vehicle.price}
                              year={vehicle?.model?.year}
                              selling_flag={vehicle?.selling_flag}
                            />
                          </div>
                        ))}
                      </div>
                      <ViewMore link={`/new-${vehicleModules[0].plural}/find`} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {componentData.data.banners && componentData.data.banners.length > 0 && (
        <div className="main_section">
          <div className="container-lg">
            <Banner
              banners={componentData.data.banners.map((banner: any) => ({
                image: banner.image,
                url: banner.link,
              }))}
              bannerStyle="big"
              redirection="newPage"
            />
          </div>
        </div>
      )}
      {((componentData.data.used_buses?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
        <>
          {(!componentData.data.banners || componentData.data.banners?.length === 0) && (
            <div className="main_section">
              <div className="container-lg">
                <div className="section_content_padding">
                  <div className="section_separator"></div>
                </div>
              </div>
            </div>
          )}
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <h3 className="main_section__title main_section__title--small main_section__title--center">
                  {locale("buy_used_bus")}
                </h3>
                <div className={style.all_vehicles}>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <>
                      <div className={`${style.all_vehicles__row} row`}>
                        {componentData.data.used_buses.map((vehicle: any) => (
                          <div key={vehicle.id} className="col-md-4 col-sm-6">
                            <SingleUsedVehicleCard
                              showroom={{
                                is_showroom: vehicle?.seller?.is_showroom,
                                image: vehicle?.seller?.showroom?.logo,
                                link: `/showrooms/showroom/${vehicle?.seller?.showroom?.id}`,
                              }}
                              image={vehicle?.images[0]?.image}
                              link={`/used-${vehicleModules[0].plural}/${vehicleModules[0].single}/${vehicle.id}`}
                              isFeatured={vehicle.listing_period.is_featured}
                              date={vehicle.created_at}
                              location={
                                vehicle?.region ? `${vehicle?.region?.name}, ${vehicle?.region?.city?.name}` : ""
                              }
                              name={`${vehicle?.model?.brand?.name} ${vehicle?.model?.name} ${vehicle?.model?.year}`}
                              price={vehicle.price}
                              phone={
                                vehicle?.seller.is_showroom
                                  ? vehicle?.seller?.branch?.phone
                                  : vehicle?.seller?.user?.phone
                              }
                            />
                          </div>
                        ))}
                      </div>
                      <ViewMore link={`/used-${vehicleModules[0].plural}/find`} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {((componentData.data.imported_buses?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
        <>
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <div className="section_separator"></div>
              </div>
            </div>
          </div>
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <h3 className="main_section__title main_section__title--small main_section__title--center">
                  {locale("buy_imported_bus")}
                </h3>
                <div className={style.all_vehicles}>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <>
                      <div className={`${style.all_vehicles__row} row`}>
                        {componentData.data.imported_buses.map((vehicle: any) => (
                          <div key={vehicle.car_id} className="col-md-4 col-sm-6">
                            <SingleUsedVehicleCard
                              showroom={{
                                is_showroom: true,
                                image: vehicle?.showroom?.logo,
                                link: `/showrooms/showroom/${vehicle?.showroom?.id}`,
                              }}
                              image={vehicle?.images[0]?.image}
                              link={`/imported-${vehicleModules[0].plural}/${vehicleModules[0].single}/${vehicle.id}`}
                              isFeatured={vehicle.listing_period.is_featured}
                              date={vehicle.created_at}
                              location={
                                vehicle?.region ? `${vehicle?.region?.name}, ${vehicle?.region?.city?.name}` : ""
                              }
                              name={`${vehicle?.model?.brand?.name} ${vehicle?.model?.name} ${vehicle?.model?.year}`}
                              price={vehicle.price}
                              phone={
                                vehicle?.seller.is_showroom
                                  ? vehicle?.seller?.branch?.phone
                                  : vehicle?.seller?.user?.phone
                              }
                            />
                          </div>
                        ))}
                      </div>
                      <ViewMore link={`/imported-${vehicleModules[0].plural}/find`} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <ShowroomsSection />
      <ArticlesSection />
    </>
  );
};

function ShowroomsSection() {
  const { locale } = useTranslation();

  // TODO: add types to the fetchers and it will propagate to the components
  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: ShowroomResource[][];
  }>({
    isFetching: true,
    data: [],
  });

  useEffect(() => {
    (async () => {
      const res = await Promise.all(vehicleModules.map((module) => getShowroomsFor(module.single, "?number=3")));

      setComponentData({
        isFetching: false,
        data: res.map((res) => res.data.showrooms.data),
      });
    })();
  }, []);

  if ((componentData.data.length > 0 && !componentData.isFetching) || componentData.isFetching) {
    return (
      <>
        <div className="main_section">
          <div className="container-lg">
            <div className="section_content_padding">
              <div className="section_separator"></div>
            </div>
          </div>
        </div>
        <div className="main_section">
          <div className="container-lg">
            <div className="section_content_padding">
              <h3 className="main_section__title main_section__title--small main_section__title--center">
                {locale("showrooms")}
              </h3>
              <div className={style.all_vehicles}>
                {componentData.isFetching ? (
                  <LoadingSkeleton count={5} />
                ) : (
                  <>
                    <ShowroomCardsSlider
                      showrooms={componentData.data.map((section) =>
                        section.map((showroom) => ({
                          name: showroom.name,
                          image: showroom.logo ?? "",
                          info: showroom.info ?? "",
                          link: `/showrooms/showroom/${showroom.id}`,
                          // types: vehicleConditions.reduce(
                          //   (acc, cur, index) =>
                          //     showroom[cur]
                          //       ? acc +
                          //         `${index !== 0 && acc !== "" ? " - " : ""}${locale(
                          //           cur as Parameters<typeof locale>[0],
                          //         )}`
                          //       : acc,
                          //   "",
                          // ),
                        })),
                      )}
                    />
                    <ViewMore link="/showrooms" />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return null;
}

function ArticlesSection() {
  const { locale } = useTranslation();

  // TODO: add types to the fetchers and it will propagate to the components
  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: {
      articles: any;
    };
  }>({
    isFetching: true,
    data: {
      articles: null,
    },
  });

  useEffect(() => {
    (async () => {
      const res = await getArticles("?number=3");
      setComponentData({
        isFetching: false,
        data: {
          articles: res.data.articles,
        },
      });
    })();
  }, []);
  if ((componentData.data.articles && !componentData.isFetching) || componentData.isFetching) {
    return (
      <>
        <div className="main_section">
          <div className="container-lg">
            <div className="section_content_padding">
              <div className="section_separator"></div>
            </div>
          </div>
        </div>
        <div className="main_section">
          <div className="container-lg">
            <div className="section_content_padding">
              <h3 className="main_section__title main_section__title--small main_section__title--center">
                {locale("news")}
              </h3>
              <div className={style.all_vehicles}>
                {componentData.isFetching ? (
                  <LoadingSkeleton count={5} />
                ) : (
                  <>
                    <div className={`${style.all_vehicles__row} row`}>
                      {componentData.data.articles
                        .filter((_: any, index: number) => index < 2)
                        .map((article: any, index: number) => (
                          <div key={index} className="col-lg-6">
                            <LatestNews {...article} />
                          </div>
                        ))}
                    </div>
                    <ViewMore link="/news" />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return null;
}
export default Home;
